import type { ConfigProviderProps } from 'antd';
import enUS from './en_US';
import jaJP from './ja_JP';
import koKR from './ko_KR';
import zhCN from './zh_CN';

import { useMemo } from 'react';
import type { AppLocale } from '../types/antd';

export const Language = {
  KO: 'ko',
  ZH: 'zh',
  JA: 'ja',
  EN: 'en',
};

export type LanguageType = (typeof Language)[keyof typeof Language];

type LocaleCache = Record<LanguageType, AppLocale>;

const localeCache: Partial<LocaleCache> = {
  [Language.ZH]: zhCN,
  [Language.EN]: enUS,
  [Language.KO]: koKR,
  [Language.JA]: jaJP,
};

export const DEFAULT_LOCALE = localeCache[Language.KO] as AppLocale;

export const useLocale = (language: LanguageType) => {
  const getLocale = (language: LanguageType): AppLocale => {
    return localeCache[language] || DEFAULT_LOCALE;
  };

  return useMemo<ConfigProviderProps>(
    () => ({
      locale: getLocale(language),
    }),
    [language]
  );
};
